import { AssetCategorySelectionValue, } from './asset-category-selection-component.domain';
import { AssetCategoryTypeSelectionValue, } from './asset-category-type-selection-component.domain';
import {TruckGrossVehicleWeight, RedbookSearchByVehiclesResponse} from '../../domain/redbook-service.domain';
import { LoanPurposeValue } from './loan-purpose-selection-component.domain';

export type AssetSelectionComponentValue = {
  category: Exclude<AssetCategorySelectionValue, null>,
  type: Exclude<AssetCategoryTypeSelectionValue, null>,
  year: string,
  make?: string,
  family?: string,
  model?: string,
  description: string,
  vehicle?: RedbookSearchByVehiclesResponse[number],
  vehicles?: RedbookSearchByVehiclesResponse,
  truckGrossVehicleWeight?: TruckGrossVehicleWeight,
  OtherCar: boolean,
  LoanPurpose?: LoanPurposeValue | null,
  vehicletype?:string,
  rbid?:number,
  rbc?:number
  newprice?:number,
  month?:number,
  makecode?:string,
  importflag?:string,
  goodretail?: number,
  goodwhs?: number,
  avgretail?: number,
  avgwhs?: number,
  bodystyle?: string,
  invalid?: boolean,
} | null;

